const INPUT_LteLIST_REDUX_PARAM = 'location/INPUT_LteLIST_REDUX_PARAM'

const INPUT_R1LIST_REDUX_PARAM = 'location/INPUT_R1LIST_REDUX_PARAM'
const INPUT_R2LIST_REDUX_PARAM = 'location/INPUT_R2LIST_REDUX_PARAM'
const INPUT_R3LIST_REDUX_PARAM = 'location/INPUT_R3LIST_REDUX_PARAM'
const INPUT_R4LIST_REDUX_PARAM = 'location/INPUT_R4LIST_REDUX_PARAM'
const INPUT_R5LIST_REDUX_PARAM = 'location/INPUT_R5LIST_REDUX_PARAM'
const INPUT_R6LIST_REDUX_PARAM = 'location/INPUT_R6LIST_REDUX_PARAM'
const INPUT_R7LIST_REDUX_PARAM = 'location/INPUT_R7LIST_REDUX_PARAM'
const INPUT_R8LIST_REDUX_PARAM = 'location/INPUT_R8LIST_REDUX_PARAM'
const INPUT_R9LIST_REDUX_PARAM = 'location/INPUT_R9LIST_REDUX_PARAM'
const INPUT_R10LIST_REDUX_PARAM = 'location/INPUT_R10LIST_REDUX_PARAM'
const INPUT_R11LIST_REDUX_PARAM = 'location/INPUT_R11LIST_REDUX_PARAM'
const INPUT_R12LIST_REDUX_PARAM = 'location/INPUT_R12LIST_REDUX_PARAM'

const INPUT_AETYPE1_LIST_REDUX_PARAM = 'location/INPUT_AETYPE1_LIST_REDUX_PARAM'
const INPUT_AETYPE2_LIST_REDUX_PARAM = 'location/INPUT_AETYPE2_LIST_REDUX_PARAM'
const INPUT_AETYPE3_LIST_REDUX_PARAM = 'location/INPUT_AETYPE3_LIST_REDUX_PARAM'

const INPUT_DiaLogListAeUserDetail_REDUX_PARAM = 'location/INPUT_DiaLogListAeUserDetail_REDUX_PARAM'
const INPUT_DiaLogListAeUserOnly_REDUX_PARAM = 'location/INPUT_DiaLogListAeUserOnly_REDUX_PARAM'

const INPUT_RESET_COUNT_REDUX_PARAM = 'location/INPUT_RESET_COUNT_REDUX_PARAM'
const INPUT_RASP_LIST_REDUX_PARAM = 'location/INPUT_RASP_LIST_REDUX_PARAM'

const INPUT_emergency_data_aeUser_REDUX_PARAM = 'location/INPUT_emergency_data_aeUser_REDUX_PARAM'
const INPUT_status_data_aeUser_REDUX_PARAM = 'location/INPUT_status_data_aeUser_REDUX_PARAM'

//status_data_aeUser
export const input_LteList_Redux_Param = (param) => ({ type: INPUT_LteLIST_REDUX_PARAM, param })

export const input_R1List_Redux_Param = (param) => ({ type: INPUT_R1LIST_REDUX_PARAM, param })
export const input_R2List_Redux_Param = (param) => ({ type: INPUT_R2LIST_REDUX_PARAM, param })
export const input_R3List_Redux_Param = (param) => ({ type: INPUT_R3LIST_REDUX_PARAM, param })
export const input_R4List_Redux_Param = (param) => ({ type: INPUT_R4LIST_REDUX_PARAM, param })
export const input_R5List_Redux_Param = (param) => ({ type: INPUT_R5LIST_REDUX_PARAM, param })
export const input_R6List_Redux_Param = (param) => ({ type: INPUT_R6LIST_REDUX_PARAM, param })
export const input_R7List_Redux_Param = (param) => ({ type: INPUT_R7LIST_REDUX_PARAM, param })
export const input_R8List_Redux_Param = (param) => ({ type: INPUT_R8LIST_REDUX_PARAM, param })
export const input_R9List_Redux_Param = (param) => ({ type: INPUT_R9LIST_REDUX_PARAM, param })
export const input_R10List_Redux_Param = (param) => ({ type: INPUT_R10LIST_REDUX_PARAM, param })
export const input_R11List_Redux_Param = (param) => ({ type: INPUT_R11LIST_REDUX_PARAM, param })
export const input_R12List_Redux_Param = (param) => ({ type: INPUT_R12LIST_REDUX_PARAM, param })

export const input_AeTypeList1_Redux_Param = (param) => ({ type: INPUT_AETYPE1_LIST_REDUX_PARAM, param })
export const input_AeTypeList2_Redux_Param = (param) => ({ type: INPUT_AETYPE2_LIST_REDUX_PARAM, param })
export const input_AeTypeList3_Redux_Param = (param) => ({ type: INPUT_AETYPE3_LIST_REDUX_PARAM, param })

export const input_DiaLogListAeUserDetail_Redux_Param = (param) => ({
  type: INPUT_DiaLogListAeUserDetail_REDUX_PARAM,
  param,
})
export const input_DiaLogListAeUserOnly_Redux_Param = (param) => ({
  type: INPUT_DiaLogListAeUserOnly_REDUX_PARAM,
  param,
})

export const input_Reset_Count_Redux_Param = () => ({
  type: INPUT_RESET_COUNT_REDUX_PARAM,
})

export const input_Rasp_List_Redux_Param = (param) => ({
  type: INPUT_RASP_LIST_REDUX_PARAM,
  param,
})

export const input_emergency_data_aeUser_Redux_Param = (param) => ({
  type: INPUT_emergency_data_aeUser_REDUX_PARAM,
  param,
})
export const input_status_data_aeUser_Redux_Param = (param) => ({
  type: INPUT_status_data_aeUser_REDUX_PARAM,
  param,
})

const initialState = {
  LteList_Redux: [],
  R1List_Redux: [],
  R2List_Redux: [],
  R3List_Redux: [],
  R4List_Redux: [],
  R5List_Redux: [],
  R6List_Redux: [],
  R7List_Redux: [],
  R8List_Redux: [],
  R9List_Redux: [],
  R10List_Redux: [],
  R11List_Redux: [],
  R12List_Redux: [],
  AeTypeList1_Redux: [],
  AeTypeList2_Redux: [],
  AeTypeList3_Redux: [],

  DiaLogListAeUserDetail_Redux: [],
  DiaLogListAeUserOnly_Redux: [],
  ResetCount: 0,
  RaspLIST: [
    {
      name: '2c_cf_67_44_61_db',
      location_desc: 'LTE게이트웨이',
      x: 79,
      y: 474,
    },
    {
      name: '2c_cf_67_44_5a_c7',
      location_desc: '게이트웨이1번',
      x: 482,
      y: 48,
    },
    {
      name: '2c_cf_67_44_60_90',
      location_desc: '리피터1번',
      x: 327,
      y: 322,
    },
    {
      name: '2c_cf_67_44_61_2a',
      location_desc: '리피터2번',
      x: 525,
      y: 136,
    },
    {
      name: '2c_cf_67_44_61_c6',
      location_desc: '리피터3번',
      x: 827,
      y: 357,
    },
    {
      name: '2c_cf_67_44_5a_17',
      location_desc: '게이트웨이2번',
      x: 972,
      y: 74,
    },
    {
      name: '2c_cf_67_2e_2f_4c',
      location_desc: '리피터4번',
      x: 972,
      y: 223,
    },
    {
      name: '2c_cf_67_44_4e_fa',
      location_desc: '리피터5번',
      x: 972,
      y: 370,
    },
    {
      name: '2c_cf_67_44_60_7c',
      location_desc: '게이트웨이3번',
      x: 168,
      y: 228,
    },
    {
      name: '2c_cf_67_44_5e_0f',
      location_desc: '리피터6번',
      x: 392,
      y: 312,
    },
    {
      name: '2c_cf_67_44_60_ae',
      location_desc: '리피터7번',
      x: 673,
      y: 239,
    },
    {
      name: '2c_cf_67_44_5e_3d',
      location_desc: '리피터8번',
      x: 812,
      y: 164,
    },
    {
      name: '2c_cf_67_44_60_5d',
      location_desc: '리피터10번',
      x: 1070,
      y: 314,
    },
  ],
  emergency_data_aeUser_Redux: [],
  status_data_aeUser_Redux: [],
}

export default function funGetRnList_Redux(state = initialState, action = {}) {
  // console.log("action:",action)
  switch (action.type) {
    case INPUT_LteLIST_REDUX_PARAM:
      return {
        ...state,
        LteList_Redux: action.param,
      }
    case INPUT_R1LIST_REDUX_PARAM:
      return {
        ...state,
        R1List_Redux: action.param,
      }
    case INPUT_R2LIST_REDUX_PARAM:
      return {
        ...state,
        R2List_Redux: action.param,
      }
    case INPUT_R3LIST_REDUX_PARAM:
      return {
        ...state,
        R3List_Redux: action.param,
      }
    case INPUT_R4LIST_REDUX_PARAM:
      return {
        ...state,
        R4List_Redux: action.param,
      }
    case INPUT_R5LIST_REDUX_PARAM:
      return {
        ...state,
        R5List_Redux: action.param,
      }
    case INPUT_R6LIST_REDUX_PARAM:
      return {
        ...state,
        R6List_Redux: action.param,
      }
    case INPUT_R7LIST_REDUX_PARAM:
      return {
        ...state,
        R7List_Redux: action.param,
      }
    case INPUT_R8LIST_REDUX_PARAM:
      return {
        ...state,
        R8List_Redux: action.param,
      }
    case INPUT_R9LIST_REDUX_PARAM:
      return {
        ...state,
        R9List_Redux: action.param,
      }
    case INPUT_R10LIST_REDUX_PARAM:
      return {
        ...state,
        R10List_Redux: action.param,
      }
    case INPUT_R11LIST_REDUX_PARAM:
      return {
        ...state,
        R11List_Redux: action.param,
      }
    case INPUT_R12LIST_REDUX_PARAM:
      return {
        ...state,
        R11List_Redux: action.param,
      }

    case INPUT_AETYPE1_LIST_REDUX_PARAM:
      return {
        ...state,
        AeTypeList1_Redux: action.param,
      }
    case INPUT_AETYPE2_LIST_REDUX_PARAM:
      return {
        ...state,
        AeTypeList2_Redux: action.param,
      }
    case INPUT_AETYPE3_LIST_REDUX_PARAM:
      return {
        ...state,
        AeTypeList3_Redux: action.param,
      }
    case INPUT_DiaLogListAeUserDetail_REDUX_PARAM:
      return {
        ...state,
        DiaLogListAeUserDetail_Redux: action.param,
      }
    case INPUT_DiaLogListAeUserOnly_REDUX_PARAM:
      return {
        ...state,
        DiaLogListAeUserOnly_Redux: action.param,
      }
    case INPUT_RESET_COUNT_REDUX_PARAM:
      return {
        ...state,
        ResetCount: state.ResetCount + 1,
      }
    case INPUT_RASP_LIST_REDUX_PARAM:
      return {
        ...state,
        RaspLIST: action.param,
      }

    case INPUT_emergency_data_aeUser_REDUX_PARAM:
      return {
        ...state,
        emergency_data_aeUser_Redux: action.param,
      }

    case INPUT_status_data_aeUser_REDUX_PARAM:
      return {
        ...state,
        status_data_aeUser_Redux: action.param,
      }

    default:
      return state
  }
}
